import { render, staticRenderFns } from "./BoletoFail.vue?vue&type=template&id=d9c4035a&scoped=true"
import script from "./BoletoFail.vue?vue&type=script&lang=js"
export * from "./BoletoFail.vue?vue&type=script&lang=js"
import style0 from "./BoletoFail.vue?vue&type=style&index=0&id=d9c4035a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c4035a",
  null
  
)

export default component.exports